import Vue from 'vue';
import Vuex from 'vuex';
import VuexOrm from '@vuex-orm/core';

import normalizer from '@/utils/normalizer';

import users from './modules/users';
import modal from './modules/modal';
import context from './modules/context';
import groups from './modules/groups';
import memberships from './modules/memberships';
import themes from './modules/themes';
import posts from './modules/posts';
import toasts from './modules/toasts';

import features from '@/store/modules/features';

import Context from '@/models/Context';
import Feature from '@/models/Feature';
import User from '@/models/core/User';
import Team from '@/models/core/Team';
import Group from '@/models/core/Group';
import Invite from '@/models/core/Invite';
import Membership from '@/models/core/Membership';
import Item from '@/models/content/Item';
import Source from '@/models/content/Source';
import Topic from '@/models/strategy/Topic';

import teams from '@/store/modules/teams';
import invites from '@/store/modules/invites';
import items from '@/store/modules/items';
import sources from '@/store/modules/sources';
import topics from '@/store/modules/topics';

Vue.use(Vuex);

const database = new VuexOrm.Database();

database.register(Context, context);
database.register(User, users);
database.register(Team, teams);
database.register(Group, groups);
database.register(Invite, invites);
database.register(Membership, memberships);
database.register(Feature, features);
database.register(Item, items);
database.register(Source, sources);
database.register(Topic, topics);

const store = new Vuex.Store({
  plugins: [VuexOrm.install(database)],
  modules: {
    modal,
    themes,
    posts,
    toasts
  },
  getters: {
    isLoading: function({ getters }) {
      const users = store.getters['entities/users/isLoading'];
      const items = store.getters['entities/items/isLoading'];
      const groups = store.getters['entities/groups/isLoading'];
      const topics = store.getters['entities/topics/isLoading'];
      const context = store.getters['entities/context/isLoading'];
      const invites = store.getters['entities/invites/isLoading'];
      const features = store.getters['entities/features/isLoading'];
      const memberships = store.getters['entities/memberships/isLoading'];

      return (
        users ||
        items ||
        groups ||
        topics ||
        context ||
        invites ||
        features ||
        memberships
      );
    }
  },
  actions: {
    normalize({ commit }, payload) {
      return new Promise(resolve => {
        normalizer.normalize(payload.model, payload.data).then(() => {
          resolve();
        });
      });
    }
  }
});

export default store;
